import { useHookstate } from "@hookstate/core"
import { UPDATED_CAR_DATA_STATE, MAP_GLOBAL_STATES } from "globalStore/globalStore"
import { useEffect } from "react"
import { isCarInUse } from '../_helperFunctions/isCarInUse';
import { carType } from '../_helperFunctions/carType';
import { isStale } from "_helperFunctions/isStale";
import { isValidLocation } from "_helperFunctions/isValidLocation";

export const useFilteredMapCarsHook = ({
  marshalCars,
  specialCars,
  memberCars,
  bewrageCars,
  fleetCars,
  notInUseCars,
  notCommunicatingCars,
  outsidePerimeter
}) => {
  const { updatedCarData: updatedCarDataState } = useHookstate(UPDATED_CAR_DATA_STATE);
  const {
    getSelectedCarsMapState,
  } = useHookstate(MAP_GLOBAL_STATES)

  useEffect(() => {
    if (
      marshalCars ||
      specialCars ||
      memberCars  ||
      bewrageCars ||
      fleetCars ||
      notCommunicatingCars ||
      notInUseCars
    ) {
      if (updatedCarDataState.get() && updatedCarDataState.get().length !== 0) {

        let allCars = JSON.parse(updatedCarDataState.get() && updatedCarDataState.get());

        let tempArray = [...allCars];
        let filterCategory = [notCommunicatingCars, notInUseCars, outsidePerimeter, fleetCars, marshalCars, specialCars, bewrageCars,memberCars]

        // let carTypeHasExplicitFilter = ((allCars[i]?.Car?.CarType === carType?.marshal) ||
        //   (allCars[i]?.Car?.CarType === carType?.handicap) ||
        //   (allCars[i]?.Car?.CarType === carType?.bevcart) ||
        //   (allCars[i]?.Car?.CarType === carType?.member));

        filterCategory.map((item, i) => {
          if (!item) {
            if (i === 0)
              tempArray = tempArray.filter(item => !isStale(item.Car))

            if (i === 1)
              tempArray = tempArray.filter(item => isCarInUse(item.Car))

            // tempArray = allCars.filter(item => isValidLocation(item.Car.Latitude, item.Car.Longitude))

            if (i === 2)
              tempArray = tempArray.filter(item => !isValidLocation(item.Car.Latitude, item.Car.Longitude))

            if (i === 3)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.member)

            // tempArray = allCars.filter(item => item.Car.CarType === !carTypeHasExplicitFilter && isCarInUse(item.Car))

            if (i === 4)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.marshal)

            if (i === 5)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.handicap)

            if (i === 6)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.bevcart)
            
            if (i === 7)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.member)
          }
        })

        getSelectedCarsMapState.set(tempArray)
        // if (allCars && allCars?.length !== 0) {
        //   for (let i = 0; i < allCars.length; i++) {
        //     let carTypeHasExplicitFilter = ((allCars[i]?.Car?.CarType === carType?.marshal) ||
        //       (allCars[i]?.Car?.CarType === carType?.handicap) ||
        //       (allCars[i]?.Car?.CarType === carType?.bevcart) ||
        //       (allCars[i]?.Car?.CarType === carType?.member));
        //     if (notCommunicatingCars) {

        //       if (
        //         (marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
        //         (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
        //         (bewrageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
        //         (fleetCars && isCarInUse(allCars[i]) && !carTypeHasExplicitFilter) ||
        //         (notCommunicatingCars && allCars[i]?.Car?.Connection === carConnectionType?.notCommunicatingCarEnabled) ||
        //         (notInUseCars && !isCarInUse(allCars[i]))
        //       ) {
        //         tempArray.push(allCars[i]);
        //       }
        //     }
        //     else if (
        //       !notCommunicatingCars && allCars[i]?.Car?.Connection !== carConnectionType?.notCommunicatingCarEnabled
        //     ) {
        //         (marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
        //         (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
        //         (bewrageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
        //         (fleetCars && isCarInUse(allCars[i]) && !carTypeHasExplicitFilter) ||
        //         (notInUseCars && !isCarInUse(allCars[i]))
        //       ) {
        //         tempArray.push(allCars[i]);
        //       }

        //     }
        //   }
        //   getSelectedCarsMapState.set(tempArray)
        // }
      }
    } else {
      let carsData = updatedCarDataState && updatedCarDataState.get().length !== 0 ? JSON.parse(updatedCarDataState.get()) : []
      getSelectedCarsMapState.set([...carsData])
    }
  }, [
    marshalCars,
    specialCars,
    bewrageCars,
    fleetCars,
    notInUseCars,
    notCommunicatingCars,
  ])

  return {
    getSelectedCarsMapState
  }

}